import { render, staticRenderFns } from "./form-cell.vue?vue&type=template&id=31e83a54&scoped=true&"
import script from "./form-cell.vue?vue&type=script&lang=js&"
export * from "./form-cell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e83a54",
  null
  
)

export default component.exports